import { createContext, ReactNode, useContext } from "react";

import { useFilterReferral } from "./filter-referral.hook";

const FilterReferralContext = createContext(
  {} as ReturnType<typeof useFilterReferral>
);
export function useFilterReferralContext() {
  return useContext(FilterReferralContext);
}

interface FilterReferralProviderProps {
  children: ReactNode;
}
export function FilterReferralProvider({
  children,
}: FilterReferralProviderProps) {
  return (
    <FilterReferralContext.Provider value={useFilterReferral()}>
      {children}
    </FilterReferralContext.Provider>
  );
}